import { all } from "@redux-saga/core/effects";

import { quotaLimitsSagas } from "modules/QuotaManager/services/QuotaLimits/sagas";
import { quotaTypesSagas } from "modules/QuotaManager/services/QuotaTypes/sagas";

export function* quotaManagerSagas() {
    yield all([
        quotaLimitsSagas(),
        quotaTypesSagas(),
    ]);
}
